angular.module('app').controller('DoacaoFormController', function($scope, $http) {
    $scope.doacao = {};
    
    $scope.initDoacao = function(){
        return {};
    };

    $scope.getPrimaryKeyStr = function(){
		var pk = '';
		            if($scope.doacao.id){
			    pk += '-'+$scope.doacao.id;
            }
				
        if(pk)
		  pk = pk.substr(1);
		
		return pk;
    };
    
    $scope.save = function($event){
        $event.preventDefault();
        
        $scope.saving = true;

        $http({
            method: $scope.getPrimaryKeyStr() ? 'PATCH' : 'POST',
            url: 'site/doacoes'+($scope.getPrimaryKeyStr() ? '/'+$scope.getPrimaryKeyStr() : ''),
            data: $scope.doacao
        }).then(function(response){
            window.location.href =  $scope.previousUrl;                            
        }).catch(function(){
            $scope.saving = false;
        });
    };
});
